const styles = {
  blackLabel: {
    background: 'black',
  },
  greenLabel: {
    background: '#27AE60',
  },
  brownLabel: {
    background: 'brown',
  },
  limeLabel: {
    background: 'lime',
  },
  redLabel: {
    background: '#D32F2F',
  },
  yellowLabel: {
    background: '#FF9800',
  },
  grayLabel: {
    background: 'grey',
  },
  purpleLabel: {
    background: 'purple',
  },
  blueLabel: {
    background: 'blue',
  },
  labelTypeSelector: {
    borderRadius: 5,
    color: 'white',
    fontFamily: 'Barlow Condensed',
    fontWeight: 600,
    fontSize: 16,
    textTransform: 'uppercase',
    width: '100%',
    textAlign: 'center',
  },
  warnImage: {
    position: 'absolute',
    top: 0,
    left: 48,
    height: 'auto',
  },
  image: {
    position: 'relative',
    top: 0,
    left: 0,
  },
  imageContainer: {
    position: 'relative',
    top: 0,
    left: 0,
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: 20,
    color: '#647886',
  },
  equipmentIconContainer: {
    width: 70,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    cursor: 'pointer',
  },
  equipmentTooltip: {
    display: 'flex',
    flexDirection: 'column',
  },
  equipmentTooltipOperators: {
    display: 'flex',
    alignItems: 'center',
  },
  titleTooltipOperators: {
    display: 'inline-block',
    maxWidth: 150,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerDynamicIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#ffa500',
    borderRadius: '50%',
    marginLeft: 10,
  },
  tooltip: {
    // '& > div': {
    //   display: 'flex',
    //   flexDirection: 'column',
    //   flexWrap: 'wrap',
    // },
    '& strong': {
      fontWeight: 500,
    },
    '& span': {
      color: '#647886',
      fontWeight: 400,
    },
  },

};

export default styles;
